<template>
  <Wrapper>
    <CommonHowToJoin></CommonHowToJoin>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import CommonHowToJoin from "../../../components/sp/howtojoin/CommonHowToJoin";
export default {
  components: {
    Wrapper,
    CommonHowToJoin,
  },
  name: "HowToJoin",
};
</script>



// WEBPACK FOOTER //
// src/pages/sp/howtojoin/HowToJoin.vue